export const LOADING = 'contributorExp.LOADING';
export const LOAD_DATA = 'contributorExp.LOAD_DATA';

export const FOLLOW = 'contributorExp.FOLLOW';
export const UNFOLLOW = 'contributorExp.UNFOLLOW';
export const FOLLOW_LOAD = 'contributorExp.FOLLOW_LOAD';
